import { create } from 'zustand';
import { User } from '../types';
import storage from '../utils/storage';
import { STORAGE_KEYS } from '../utils/constants';

interface AuthState {
  // 状态
  isLoggedIn: boolean;
  token: string | null;
  user: User | null;
  
  // 操作
  setToken: (token: string) => Promise<void>;
  setUser: (user: User) => void;
  login: (token: string, user: User) => Promise<void>;
  logout: () => Promise<void>;
  loadAuthState: () => Promise<void>;
}

/**
 * 认证状态管理
 */
export const useAuthStore = create<AuthState>((set) => ({
  // 初始状态
  isLoggedIn: false,
  token: null,
  user: null,

  // 设置 token
  setToken: async (token: string) => {
    await storage.setItem(STORAGE_KEYS.TOKEN, token);
    set({ token, isLoggedIn: !!token });
  },

  // 设置用户信息
  setUser: (user: User) => {
    set({ user });
  },

  // 登录
  login: async (token: string, user: User) => {
    await storage.setItem(STORAGE_KEYS.TOKEN, token);
    set({
      isLoggedIn: true,
      token,
      user,
    });
  },

  // 登出
  logout: async () => {
    await storage.removeItem(STORAGE_KEYS.TOKEN);
    set({
      isLoggedIn: false,
      token: null,
      user: null,
    });
  },

  // 加载认证状态（应用启动时调用）
  loadAuthState: async () => {
    const token = await storage.getItem<string>(STORAGE_KEYS.TOKEN);
    if (token) {
      set({
        isLoggedIn: true,
        token,
      });
      // TODO: 可以在这里调用 API 获取用户信息
    }
  },
}));
